// M1.5 Madurez — mapeo de errores del motor IA a mensaje amable (prompt 0730 F3).
// Puro (sin React): traduce code/status del backend a un texto i18n legible, en vez
// de mostrar "Error 502" crudo. Usado por MadurezAnalisisIA.

type Traducir = (clave: string, fallback: string) => string;

/** Traduce un error del motor IA (code/status del backend) a un mensaje amable. */
export function mensajeErrorIA(err: unknown, s: Traducir): string {
  const e = err as { code?: string; status?: number; message?: string };
  if (e.code === 'AI_ALL_PROVIDERS_FAILED' || e.status === 502) {
    return s(
      'errMotorNoDisponible',
      'El motor de IA no está disponible o sin cuota. Reintenta o revisa los proveedores.',
    );
  }
  if (e.code === 'AI_INVALID_RESPONSE' || e.status === 422) {
    return s('errRespuestaInvalida', 'La IA devolvió una respuesta no válida. Reintenta.');
  }
  return e.message ?? s('errGenerico', 'Se produjo un error. Reintenta.');
}
